/* eslint-disable react/require-default-props */
import React from 'react';

export interface IButton {
  id?: string;
  variant?: 'primary' | 'secondary' | 'outlined';
  children: React.ReactNode;
  onClick?: (args?: any) => any;
  className?: string;
  disabled?: boolean;
  testId?: string;
  style?: React.CSSProperties;
  type?: 'button' | 'submit';
}

const Button = ({
  id,
  variant = 'primary',
  children,
  onClick,
  className = '',
  style,
  disabled = false,
  testId,
  type = 'button',
}: IButton) => {
  return (
    <button
      id={id}
      data-testid={testId}
      className={`button-hotels ${variant} ${className}`}
      type={type === 'button' ? 'button' : 'submit'}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;
